import React from 'react';
import { Text, Stack } from 'basis';
import { LayoutPage, LayoutSection } from 'components';
import { useAppContext } from 'hooks';

export const AssistedApplyReferred: React.FC = () => {
  const { state } = useAppContext();

  return (
    <LayoutPage step="outcome">
      <LayoutSection>
        <Stack gap="8">
          <Text as="h1" textStyle="heading5" textStyle-md="heading4" color="indigo">
            We've successfully received your application
          </Text>
          {state.appNum && (
            <Text>
              Application reference number: <strong data-hj-suppress>{state.appNum}</strong>
            </Text>
          )}
          <Text>Thanks for applying for a Gem Visa credit card.</Text>
          <Text>
            Right now, your application is being reviewed by one of our team members. We'll get back
            to you as soon as possible to confirm next steps.
          </Text>
          <Text>Thank you for your patience.</Text>
        </Stack>
      </LayoutSection>
    </LayoutPage>
  );
};
